import { useTranslation } from 'react-i18next';
import {
  getOrganizationType,
  getOrganizationTypeCapitalized,
} from '../utils/index';

/**
 * Custom hook to get organization-aware translations
 * @returns {Object} - Translation functions with organization type replacement
 */
export const useOrganizationTranslation = () => {
  const { t, i18n } = useTranslation();

  const orgType = getOrganizationType();
  const orgTypeCapitalized = getOrganizationTypeCapitalized();

  /**
   * Get translation with organization type interpolation
   * @param {string} key - Translation key
   * @param {Object} options - Additional interpolation options
   * @returns {string} - Translated text with organization type replaced
   */
  const tOrg = (key, options = {}) => {
    const translatedText = t(key, options);

    // Replace organization type placeholders
    return translatedText
      .replace(/{{organization_type}}/g, orgType)
      .replace(/{{Organization_type}}/g, orgTypeCapitalized)
      .replace(/{{ORGANIZATION_TYPE}}/g, orgType.toUpperCase());
  };

  return {
    t: tOrg,
    tOriginal: t, // Original translation function for cases where org replacement is not needed
    i18n,
    orgType,
    orgTypeCapitalized,
  };
};
